import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import { routesWithoutBackground, routesWithoutHeader, RuningInLink } from "@/constants";
import BG_TOP_RIGHT from "../assets/common/bg_layout.png";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import AIQA from "./AIQA";
import AIQAStore from "@/store/AIQA.store";
import "./index.less";
import loginStore from "@/store/login.store";
import appStore from "@/store/app.store";
import { DataFlowApis } from "@core/ability";
import { getFullScreen, subscribeFullScreenStatus, subscribeMaxsizeStatus, getMaximizedStatus, subscribeHasUpgrateStatus, subscribeUpgrateStatus } from "@/utils/window";
import userInfoStore from "@/store/user.store";
import fridayReporter from "@/utils/friday";
import { UpgrateStatus, UpgrateStatusMap } from "@/constants/upgrate";
import { maxMobileWidth } from "@/constants/share";
import { useInit } from "./useInit";
import { IS_PRIVATE } from "@/config";
const isWindows = navigator.platform.indexOf("Win") !== -1;

// 只有首页展示个人信息
const routerInfo = ["/home"];
const routerWithoutMaxBtn = ['/login'];

function Layout() {
  const location = useLocation();
  const showHeader = !routesWithoutHeader.includes(location.pathname);
  const showBg = !routesWithoutBackground.includes(location.pathname);
  const showInfo = routerInfo.includes(location.pathname);
  const showMaxBtn = !routerWithoutMaxBtn.includes(location.pathname);
  const userId = userInfoStore((state) => state.userId);
  const formatUserName = userInfoStore((state) => state.formatUserName);
  const isMobile = document.documentElement.clientWidth <= maxMobileWidth  && !window.LinkService;
  const navigate = useNavigate();
  useInit();

  const isAIQAMode = AIQAStore((store) => store.isAIQAMode);
  const toggleAIQAMode = AIQAStore((store) => store.toggleAIQAMode);
  const ClientAIQAMode = isAIQAMode && RuningInLink && !IS_PRIVATE;
  const setMainRef = AIQAStore((store) => store.setMainRef);

  const mainRef = useRef<HTMLDivElement>(null);

  const hasLogin = loginStore((state) => state.hasLogin);

  const setIsSupportFullScreen = appStore((store) => store.setIsSupportFullScreen);

  const setIsSupportMaximize = appStore((store) => store.setIsSupportMaximize);

  const setIsSupportExport = appStore((store) => store.setIsSupportExport);

  const initFullScreen = async () => {
    try {
      const res = await getFullScreen();
      setIsSupportFullScreen(true);
      appStore.setState({ isFullScreen: res.data });
    } catch (error) {
      setIsSupportFullScreen(false);
      console.error("不支持全屏模式");
    }
  };

  useEffect(() => {
    if(!userId) return;
    fridayReporter.setUser({
      id: userId,
    });
    fridayReporter.setEnv({
      u_id: userId,
      u_name: formatUserName
    });
  }, [userId, formatUserName]);
  

  const initMaximize = async () => {
    try {
      const res = await getMaximizedStatus();
      setIsSupportMaximize(true);
      appStore.setState({ isMaximize: res.data });
    } catch (error) {
      setIsSupportMaximize(false);
      console.error("不支持最大化");
    }
  };

  const initExport = async () => {
    const isSupport = await DataFlowApis.supportDataFlow();
    setIsSupportExport(isSupport);
  }

  useEffect(() => {
    if (!hasLogin) {
      toggleAIQAMode(false, false);
    }
  }, [hasLogin]);

  useEffect(() => {
    window.navigate = navigate;
    initExport();
    if (isWindows) {
      initMaximize();
      subscribeMaxsizeStatus((data) => {
        appStore.setState({ isMaximize: data.data });
      });
    } else {
      setMainRef(mainRef);
      initFullScreen();
      subscribeFullScreenStatus((data) => {
        appStore.setState({ isFullScreen: data.data });
      });
    }

    subscribeHasUpgrateStatus((data)=>{
      appStore.setState({ hasUpdate: data.data });
    })

    subscribeUpgrateStatus((data) => {
      const upgrateStatus = data.data.event as UpgrateStatus;
      console.log("upgrateStatus", upgrateStatus);
      if (!UpgrateStatusMap[upgrateStatus]) return;
      fridayReporter.pushData({
        eventCode: "HomePage_upgrade_finish",
        payload: {
          origin_verision: appStore.getState().currentVersion,
          new_version: appStore.getState().newVersion,
          upgrade_status: UpgrateStatusMap[upgrateStatus],
        },
      });
    });

    return () => {
      toggleAIQAMode(false, false);
    };
  }, []);

  return (
    <div
      className={`${isMobile ? "bg-#F2F3F5" : showBg ? "bg-#F2F3F5/88" : "bg-white"} h-full flex flex-col select-none shadow overflow-hidden relative bg-no-repeat bg-contain ${ClientAIQAMode ? "aiqa-mode-app" : "app"
        }`}
      style={{ backgroundImage: showBg && !isMobile ? `url(${BG_TOP_RIGHT})` : "" }}
    >
      <main className="layout-bg flex flex-1 overflow-hidden z-0">
        <div className={`flex flex-col flex-1 overflow-hidden h-100% ${ClientAIQAMode ? "aiqa-mode-left" : "main-left"}`} ref={mainRef}>
          {showHeader && RuningInLink && <Header showInfo={showInfo} showMaxBtn={showMaxBtn} />}
          <div className={`flex-1 overflow-hidden`}>
            <Outlet />
          </div>
        </div>
        {ClientAIQAMode && <AIQA />}
      </main>
    </div>
  );
}

export default Layout;
